import { Skeleton } from "@mui/material";
import { PageBreadcrumb } from "src/components/PageBreadcrumb";
import { PageHeader } from "src/components/PageHeader/PageHeader";

export const ChangeManagementPlanSkeleton = () => (
  <div
    className="flex flex-col"
    aria-label="Loading change management plan"
    aria-busy="true"
  >
    <PageHeader
      pageTitleComponent={
        <PageBreadcrumb
          items={[
            { label: "Change management" },
            { label: <Skeleton width={160} /> },
          ]}
        />
      }
      rightPanelToggleRequiresDevice={false}
    />
    <div className="flex flex-col gap-6 p-4" aria-hidden="true">
      <div className="flex flex-col gap-2">
        <Skeleton width={320} height={34} />
        <Skeleton width={140} />
      </div>
      <div className="flex flex-col gap-3 rounded border border-solid border-black/[.12] bg-white px-5 py-4">
        <Skeleton width={200} />
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton key={index} variant="rounded" height={72} />
        ))}
      </div>
      {Array.from({ length: 2 }, (_, index) => (
        <Skeleton key={index} variant="rounded" height={160} />
      ))}
    </div>
  </div>
);
